import { useMemo } from "react";
import { useRouterState } from "@tanstack/react-router";
import { PERMISSION_FREE_MODULE, PERMISSION_FREE_ROUTES, PERMISSION_ROUTE_MODULES } from "@apv-erp/status";
import { DUAL_AXIS_NAVIGATION } from "@/config/navigation";

const norm = (p: string) => (p || "").split("?")[0].replace(/\/$/, "");

/** Đường dẫn → module phân quyền: mục menu + danh mục bổ sung (permission-catalog), khớp tiền tố dài nhất */
const PATH_MODULES: Array<{ path: string; moduleId: string }> = [
  ...DUAL_AXIS_NAVIGATION.flatMap((d) => d.tabs.filter((t) => t.moduleId).map((t) => ({ path: norm(t.href), moduleId: t.moduleId as string }))),
  ...PERMISSION_ROUTE_MODULES.map((r) => ({ path: norm(r.path), moduleId: r.module })),
  ...PERMISSION_FREE_ROUTES.map((p) => ({ path: norm(p), moduleId: PERMISSION_FREE_MODULE })),
]
  .filter((m) => m.path)
  .sort((a, b) => b.path.length - a.path.length);

/** Module phân quyền của một đường dẫn; null nếu không thuộc module nào */
export function moduleForPath(pathname: string): string | null {
  const p = norm(pathname);
  const hit = PATH_MODULES.find((m) => p === m.path || p.startsWith(m.path + "/"));
  return hit?.moduleId ?? null;
}

/**
 * Module phân quyền của màn đang mở (04/11/2026) — dùng cho quyền In / Xuất DL ở nút dùng chung (ExportImportButtons,
 * PrintDialog, useExcelExport, chốt chặn window.print) mà không phải truyền tay ở từng màn.
 */
export function usePermissionModule(): string | null {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return useMemo(() => moduleForPath(pathname), [pathname]);
}
